import _ from 'lodash';

import { getChangeLabel, getDrawerAuthorKey } from '../../PendingChangesDrawer.utils';

export const getAffectedToggleText = ({
  affectedChanges,
  totalAffectedCount,
  isAffectedNarrowed,
}) =>
  isAffectedNarrowed
    ? `${affectedChanges.length} of ${totalAffectedCount} affected ${getChangeLabel(totalAffectedCount)} match`
    : `${affectedChanges.length} affected ${getChangeLabel(affectedChanges.length)}`;

// One save can hold changes made by several people, and the filters narrow the direct changes, so the
// header names everyone behind the changes still shown rather than the author of the first one.
const getAuthorNames = ({ directChanges, formattedFullName }) => {
  const names = _.uniqBy(directChanges, getDrawerAuthorKey)
    .map(change => change.formattedFullName)
    .filter(Boolean);

  return names.length ? names.join(', ') : formattedFullName;
};

export const getOperationMetaText = (group, relativeTime) => {
  const { directChanges, tabName } = group;
  const authorAndTime = [getAuthorNames(group), relativeTime].filter(Boolean).join(' · ');

  if (directChanges.length > 1 && tabName) {
    return `Saved together on ${tabName} · ${authorAndTime}`;
  }

  return authorAndTime;
};
